import React from "react";
import "./button.scss";

const Button = ({ text, type, width = false, onClick, ...rest }) => {
  return (
    <button
      type={type}
      className={` submitBtn  ${width ? "changeWidth" : ""}`}
      onClick={onClick}
      {...rest}
    >
      {text}
    </button>
  );
};

export default Button;
